import { FC, ReactNode } from "react"

import { StageTenAPI2023March } from "./2023-03/StageTenApi2023March"
import { StageTenApiVersions } from "./SdkTypes"

export type StageTenAPIProps = {
  version: keyof typeof StageTenApiVersions
  children?: ReactNode
  disabled?: boolean
}

export const StageTenAPI: FC<StageTenAPIProps> = (props) => {
  if (props.disabled === true) {
    return props.children
  }
  if (props.version === "2023-03") {
    return <StageTenAPI2023March>{props.children}</StageTenAPI2023March>
  }

  // Throw if deprecated API version or no version was requested
  throw Error("Unsupported StageTenApi version")
}
